import { clearUserContext } from '../helpers/sentryHelpers';

export const me = async (token) => {
  // configure the fetch url
  let url = '/auth/me';

  // if there is a token token, add it to the url
  if (Object.keys(token).length > 0) {
    const tokenString = encodeURIComponent(JSON.stringify(token));
    url += `?token=${tokenString}`;
  }

  const res = await fetch(url);
  const data = await res.json();

  if (!res.ok) {
    // Check if this is an expired invitation
    if (data.invitationExpired && data.redirectTo) {
      // Redirect to the home page with alert message
      window.location.href = data.redirectTo;
      return; // Don't throw error, we're redirecting
    }
    throw new Error(data.message || 'Failed to fetch user');
  }

  return data;
};

export const logout = () => {
  // Clear Sentry user context before logout
  clearUserContext();

  fetch('/api/analytics/logout', {
    method: 'POST',
  }).finally(() => {
    window.location.href = `${process.env.REACT_APP_URL}/logout`;
  });
};
